// extracted by mini-css-extract-plugin
export var deliveryRow = "_qj-a";
export var fixedHeight = "_qj-4";
export var freightLogo = "_qj-9";
export var fullWidth = "_qj-3";
export var priceColumn = "_qj-5";
export var radioSelected = "_qj-7";
export var radioUnselected = "_qj-6";
export var selectedOption = "_qj-2";
export var selectedOptionContainer = "_qj-1";
export var selection = "_qj-0";
export var tallSkeletonText = "_qj-8";